module.exports = __webpack_public_path__ + "img/edit.79a8e85c.svg";